// extracted by mini-css-extract-plugin
export default {"Container":"DropdownMenu_Container__872gZ","dropdown-item":"DropdownMenu_dropdown-item__GgJtp"};